import { render, staticRenderFns } from "./ManageInvitations.vue?vue&type=template&id=d1e9ff3a"
import script from "./ManageInvitations.vue?vue&type=script&lang=js"
export * from "./ManageInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports